import type { AuditEntry } from '@/api/types'
import { titleCase } from './format'

/** Render any audit value as short text. undefined = "not recorded" (legacy rows). */
export function formatAuditValue(v: unknown): string {
  if (v === undefined) return 'not recorded'
  if (v === null) return 'empty'
  if (typeof v === 'boolean') return v ? 'on' : 'off'
  if (typeof v === 'string') return v === '' ? '""' : v
  if (typeof v === 'number') return String(v)
  try {
    return JSON.stringify(v)
  } catch {
    return String(v)
  }
}

export const AUDIT_ACTIONS = ['create', 'update', 'delete'] as const

/** Entity types the backend writes today (auditLog entityType values), for the filter. */
export const AUDIT_ENTITY_TYPES = [
  'league',
  'subscription',
  'user',
  'settings',
  'sport_pack',
  'season',
  'season_team',
  'team',
  'player',
  'game',
  'box_score',
  'tournament',
  'score_bug',
  'live_event',
  'page',
  'nav_menu',
  'homepage_layout',
  'announcement',
  'featured',
  'quick_link',
  'sponsor',
  'media',
  'venue',
  'ticket_type',
  'ticket',
  'ticket_order',
  'ticket_sale',
  'impersonation',
  'staff_invite',
  'password_reset',
] as const

/** One line describing an entry when the server didn't write a summary (legacy rows). */
export function auditHeadline(e: AuditEntry): string {
  if (e.summary) return e.summary
  const verb = e.action === 'create' ? 'Created' : e.action === 'delete' ? 'Deleted' : e.action === 'update' ? 'Updated' : titleCase(String(e.action))
  const what = e.entity_type ? e.entity_type.replace(/_/g, ' ') : 'record'
  return `${verb} ${what}${e.entity_id != null ? ` #${e.entity_id}` : ''}`
}
